import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Seo from "../../components/seo"

const LandingPageSEO = () => {
  const metaData = useStaticQuery(graphql`
    query {
      wpCustomPage(databaseId: { eq: 2949 }) {
        SEOmeta {
          metaTitle
          metaDescription
          metaKeywords
          ogTitle
          ogDescription
          ogImage {
            localFile {
              childImageSharp {
                fluid(maxWidth: 1320, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          twitterTitle
          twitterDescription
          twitterImage {
            localFile {
              childImageSharp {
                fluid(maxWidth: 1320, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <div>
      <Seo
        title={metaData.wpCustomPage.SEOmeta.metaTitle}
        description={metaData.wpCustomPage.SEOmeta.metaDescription}
        keywords={metaData.wpCustomPage.SEOmeta.metaKeywords}
        ogTitle={metaData.wpCustomPage.SEOmeta.ogTitle}
        ogDescription={metaData.wpCustomPage.SEOmeta.ogDescription}
        ogImage={
          metaData.wpCustomPage.SEOmeta.ogImage.localFile.childImageSharp.fluid
        }
        twitterTitle={metaData.wpCustomPage.SEOmeta.twitterTitle}
        twitterDescription={metaData.wpCustomPage.SEOmeta.twitterDescription}
        twitterImage={
          metaData.wpCustomPage.SEOmeta.twitterImage.localFile.childImageSharp
            .fluid
        }
      />
    </div>
  )
}

export default LandingPageSEO
